import React from 'react';
import { createRoot } from 'react-dom/client';
import { Theme } from '@radix-ui/themes';
import { TooltipProvider, configureAvatarBaseUrl } from '@bliks-io/ui';
import { V2App } from './App';
import './app-sources.css';
import './index.css';
import './theme.css';
import { bindHtmlLangToLanguage } from './lib/i18n';
import { env } from './config/env';
import { installChunkLoadRecovery } from './lib/chunk-load-recovery';

async function enableMocking() {
  if (!env.USE_MOCK) {
    return;
  }

  const { worker, workerOptions } = await import('./mocks/browser');

  return worker.start(workerOptions);
}

// The backend serves avatars as root-relative paths; resolve them against the
// API origin (same as every API call) so they load when the SPA and API run on
// different ports in dev. Same-origin in prod, where BACKEND_ENDPOINT matches.
configureAvatarBaseUrl(env.BACKEND_ENDPOINT);
installChunkLoadRecovery();
bindHtmlLangToLanguage();

const container = document.getElementById('root')!;
const root = createRoot(container);

// Enable mocking before rendering the app
enableMocking().then(() => {
  root.render(
    <React.StrictMode>
      <Theme>
        {/*
          App-wide context for @bliks-io/ui tooltips. radix Tooltip throws without
          an ancestor provider, and <Theme>'s own provider is a separate react-tooltip
          instance (Vite pre-bundles @radix-ui/themes) so it doesn't satisfy ours.
          Local providers may still nest to override delayDuration.
        */}
        <TooltipProvider delayDuration={0}>
          <V2App />
        </TooltipProvider>
      </Theme>
    </React.StrictMode>
  );
});
